import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imageWidget_template } from "./imageWidget_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {validationsList_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';

declare var ko: any;

export class header_sub_menu_edit_template extends vnTemplate {
    readonly disallowedSubItemMenus: string[] = ['footer','header']; 
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    public imagePicker :imagePicker_template;
    public imageWidgetForBrandTagImage : imageWidget_template;
    public imagePickerHelper: imagePickerHelper;
    public searchFilter: filterSimple_template;

    public tagFilter: filterAutocomplete_template;
    public categoryFilter: filterAutocomplete_template;

    protected initPartial() {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller)
        this.pagination.getTemplateViewModel().itemPerPage = 10;

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel, 
            this.caller.getVnAppZone(),
            this.caller
        );
        this.imageWidgetForBrandTagImage = new imageWidget_template('menu_image', this.getTemplateViewModel(), this);
        this.imageWidgetForBrandTagImage.setMode('single-select');
        this.imageWidgetForBrandTagImage.setCaller(this.imagePickerHelper);

        this.tagFilter = new filterAutocomplete_template("filterAutocompleteTag_template", this.getTemplateViewModel(), this.caller);
        this.tagFilter.setPlaceholderAndLabel( 'Tag' );
        this.tagFilter.setIsShowCurrentSelection(false);
        this.tagFilter.setAddNewOptionEnabled(false);

        this.categoryFilter = new filterAutocomplete_template("filterAutocompleteCategory_template", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setPlaceholderAndLabel( 'Category' );
        this.categoryFilter.setIsShowCurrentSelection(false);
        this.categoryFilter.setAddNewOptionEnabled(false);

        this.searchFilter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

    }

    protected getTemplateHtml(): string {
        return (

          /* html*/`
        <div class="list-header w-justify">
            <div class="w-left">
                <!-- ko if:  $root.headerSubMenu.inSubMenu() -->
                    <button class="btn secondary" data-bind="event: {click : $root.headerSubMenu.onBackActionToSubMenu }">Back to Header Sub Menu</button>
                <!-- /ko -->
                
                <!-- ko ifnot: $root.headerSubMenu.inSubMenu() -->
                    <button class="btn secondary" data-bind="event: {click : $root.headerSubMenu.onBackAction }">Back to Menu list</button>
                <!-- /ko -->
                    
                <button class="btn secondary" data-bind="visible: items().length == 0, event: {click : $root.headerSubMenu.onClickShowAddItem }">Add Root Item</button>
            </div>

            
            <div class="w-right"></div>
        </div>

        <div class="list-header w-justify">
            <div class="w-center">
                <div class="w-nav-prev">
                    <label class="form-label">Navigation Preview</label>
                    <ul data-bind="template: { name: 'item-preview-template', foreach: $root.headerSubMenu.subItemsOf(null) }"></ul>
                </div>
            </div>
        </div>

        <div class="list-header w-justify">
            <div class="w-center">
                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                    <div class="w-search-feild icon i-search2">
                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                        <input data-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- ko if: $root.headerSubMenu.inSubMenu() -->
            <div class="list-header">
                <button class="btn secondary" data-bind="event: {click : $root.headerSubMenu.onClickExpandAll }">Expand All</button>
                <button class="btn secondary" data-bind="event: {click : $root.headerSubMenu.onClickCloseAll }">Close All</button>
            </div>
        <!-- /ko -->

        <script id="item-preview-template" type="text/html">
            <li data-bind="css: { 'icon i-dropdown': $root.headerSubMenu.hasSubItems($data)}">
                <span data-bind="text: label"></span>
                <ul data-bind="template: {name: 'item-preview-template', foreach: $root.headerSubMenu.subItemsOf($data)}"></ul>
            </li>
        </script>

            <div class="w-form w-form-large">
                <!-- ko if: $root.headerSubMenu.filteredItems().length < 1 -->
                    <div data-bind="template: { name: 'item-template', foreach: $root.headerSubMenu.subItemsOf(null) }"></div>
                <!-- /ko -->
                <!-- ko if: $root.headerSubMenu.filteredItems().length > 0 -->
                    <div data-bind="template: { name: 'item-template', foreach: $root.headerSubMenu.subItemsOf(null) }"></div>
                <!-- /ko -->
                    
                    <div class="form-footer">
                        <!-- ko ifnot: $root.headerSubMenu.inSubMenu() -->
                            <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                        <!-- /ko -->
                        <!-- ko if: $root.headerSubMenu.inSubMenu() -->
                            <button data-bind="event: { click: onClickSaveAndStay }" class="btn " type="button">Save and Stay</button>
                        <!-- /ko -->
                        <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                    </div>
                
            </div>

            <script id="item-template" type="text/html">
          
                <div class="nav-builder-entry draggable" draggable="true" data-bind="attr: { id: 'draggableMenuItem_' + id }, 
                visible: !hidemyself() ">  
             
                    <!-- ko ifnot: $data.showEdit -->
             
                        <div class="w-justify" data-bind="{event: {mouseenter: $root.headerSubMenu.showActions, mouseleave:  $root.headerSubMenu.hideActions}}">
                  
                  
                            <div class="w-left" >
                                <span class="icon i-drag"></span>
                                <span class="btn no-bg child icon i-return"></span>
                                
                                <span style="display:flex;">
                                    <!-- ko ifnot: $root.headerSubMenu.inSubMenu() -->
                                        <span class= "btn no-bg child icon i-move_up" data-bind="{event: { click: $root.headerSubMenu.onClickMoveToTop }}"></span>
                                    <!-- /ko -->
                                    <!-- ko if: $root.headerSubMenu.inSubMenu() && $root.headerSubMenu.canAddChild($data) -->
                                    <span class="btn no-bg child icon i-dropdown-simple-b"
                                            style="transform: rotate(180deg)"
                                            data-bind="{ event: { click: $root.headerSubMenu.onClickMinimizeExpandChildren },
                                                        visible: containsChild }"></span>

                                    <!--/ko -->
                                    <div class="btn no-bg child icon" data-bind="css: { 'i-image': image }"></div>
                                    <strong class="nav-builder-label" data-bind="text: label"></strong>
                                </span>
                                <span class="nav-builder-slug" data-bind="text: url"></span>
                                <div data-bind="foreach: tags">
                                    <span class= "nav-builder-slug" data-bind="text: name ? name : ''"></span>
                                </div>
                            
                                <!--Read only-->
                      
                            </div>
                  
                            <div class="w-right">

                                <div data-bind="css: { 'is-showing': $root.headerSubMenu.showActionId() == $data.id }" class="add-btn ">
                                    <button data-bind="event: { click: $root.headerSubMenu.onClickShowAddBefore }" class="btn no-bg icon before i-add-before">Add before</button>
                                    <button data-bind="event: { click: $root.headerSubMenu.onClickShowAddAfter }" class="btn no-bg icon i-add-after">Add after</button>

                                    <!-- ko if: $root.headerSubMenu.inSubMenu() && $root.headerSubMenu.canAddChild($data) -->
                                        <button data-bind="event: { click: $root.headerSubMenu.onClickShowAddChild }" class="btn no-bg icon i-return">Add Sub-Item</button>
                                    <!-- /ko -->

                                    <!-- ko ifnot: ($root.headerSubMenu.inSubMenu() || $root.headerSubMenu.isDefaultMenu()) -->
                                        <!-- ko ifnot: isLocked -->
                                            <button data-bind="event: { click: $root.headerSubMenu.onClickShowAddSubItem }" class="btn no-bg icon i-return">Add Sub-Menu</button>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                    
                                </div>
                                <!-- ko if: isLocked -->
                                    <span class="tooltips" data-bind="text: lockedBy"></span>
                                    <span class="btn no-bg child icon i-lock" data-bind="event: { mouseenter: $root.headerSubMenu.onHoverLockIcon, mouseleave: $root.headerSubMenu.onLeaveLockIcon }"></span>
                                <!-- /ko -->
                                <!-- ko ifnot: isLocked -->
                                    <button data-bind="event: { click: $root.headerSubMenu.onClickShowEdit}" class="btn only-icon icon i-edit" type="button"></button>
                                    <button data-bind="event: { click: $root.headerSubMenu.onClickSoftDelete }" class="btn only-icon icon i-delete" type="button"></button>
                                <!-- /ko -->
                            </div>
                        </div>
             
                    <!-- /ko -->
              
                    <!-- ko if: $root.headerSubMenu.hasSubItems($data) && $root.headerSubMenu.inSubMenu() -->
                        <div class="nav-builder-entry-children" data-bind="template: {name: 'item-template', foreach: $root.headerSubMenu.subItemsOf($data)}"></div>        
                    <!-- /ko -->
              
                </div>
                <!-- ko ifnot: $root.headerSubMenu.hasSubItems($data) && $root.headerSubMenu.inSubMenu() -->
                    <div data-bind="visible: $data.showAddChild" class="nav-builder-entry">
                        <div class="nav-builder-add w-justify">
                            <div class="w-left">
                            
                                <input placeholder="label" class="input-text" type="text" name="" data-bind="attr: { id: 'addChildLabel_' + id }">
                                <input placeholder="URL" class="input-text" type="text" name="" data-bind="attr: { id: 'addChildUrl_' + id }">
                                                    
                                <button data-bind="event: { click: $root.headerSubMenu.onClickHideAddChild }" class="btn highlight only-icon icon i-close" type="button"></button>
                                <button data-bind="event: { click: $root.headerSubMenu.onClickAddChild }" class="btn only-icon border icon i-check" type="button"></button>
                            </div>
                        </div>
                     </div>
                <!-- /ko -->
          
                <div data-bind="visible: $data.showAddAfter" class="nav-builder-add w-justify">
                    <div class="w-left">
                  
                        <input placeholder="label" class="input-text" type="text" name="" data-bind="attr: { id: 'addAfterLabel_' + id }">
                        <input placeholder="URL" class="input-text" type="text" name="" data-bind="attr: { id: 'addAfterUrl_' + id }">  
                        <div class="w-form-check-inline">
                            <div class="form-check-inline width-auto" data-bind="visible: $parent.canSetSection">
                            
                                <label class="form-label icon i-check" data-bind="attr : { 'for' : 'addAfterIsSection_' + id }">Section title</label>
                            </div>
                        </div>
                                          
                        <button data-bind="event: { click: $root.headerSubMenu.onClickHideAddAfter }" class="btn highlight only-icon icon i-close" type="button"></button>
                        <button data-bind="event: { click: $root.headerSubMenu.onClickAddAfter }" class="btn only-icon border icon i-check" type="button"></button>
                    </div>
                </div>
     
            </script>
      
                      
            <!-- Confiration Form --> 
            <div data-bind="if: $root.headerSubMenu.deleteConfirmation()" class="w-form sticky">
                <!-- ko with: deleteConfirmation() -->
                    <div class="form-header">
                        <h3 class="form-title icon i-edit">Delete &nbsp;<span data-bind="text: label"></span></h3>
                    </div>
                    <form class="form-body">
                        <div class="form-group">
                            <p>Are you sure you want to delete <span  data-bind="text: label"></span> and all it's sub-menu.</p>
                        </div>
                        <div class="form-footer">                
                            <button data-bind="event: { click: $root.headerSubMenu.onClickHardDelete }" class="btn highlight" type="button">Delete</button>
                            <button data-bind="event: { click: $root.headerSubMenu.onClickCancelSoftDelete }" class="btn " type="button">Cancel</button>            
                        </div>
                
                    </form>
                <!-- /ko -->
            </div>

            <!-- Re-locking Form --> 
            <div data-bind="if: $root.headerSubMenu.showReLock()" class="w-form sticky">
                <!-- ko with: showReLock() -->
                    <div class="form-header">
                        <h3 class="form-title icon i-edit">Are you still editing ?</h3>
                    </div>
                    <form class="form-body">
                        <div class="form-group">
                            <p>Click confirm if you are still editing.</p>
                        </div>
                        <div class="form-footer">                
                            <button data-bind="event: { click: $root.headerSubMenu.onClickRelock }" class="btn highlight" type="button">Confirm</button>
                            <button data-bind="event: { click: $root.headerSubMenu.onClickCancelRelock }" class="btn " type="button">Cancel</button>            
                        </div>
                
                    </form>
                <!-- /ko -->
            </div>

            <div data-bind="css: { 'is-visible': showAddForm }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Add Header Menu Item</h3>
                        </div>
                        
                        <div class="w-form-body">
                            <div class="form-body single-column-image-loader">
                                <div class="form-group">
                                    <label class="form-label">Name</label>
                                    <input placeholder="label" class="input-text" type="text" name="" id="addRootLabel">
                                </div>
                                
                                <div class="form-group">
                                    <label class="form-label">Add URL</label>
                                    <input placeholder="URL" class="input-text" type="text" name="" id="addRootUrl">
                                </div>
                                <!-- ko ifnot: $root.headerSubMenu.inSubMenu() || $root.headerSubMenu.isDefaultMenu() -->
                                    <!-- ko ifnot: $root.headerSubMenu.isMltBrand() -->
                                        <strong class="form-sub-title">Tags</strong>
                                        <div class="form-group relative-current-selection">
                                            ${ this.tagFilter.getHtmlBuild() }
                                        </div>
                                        <div data-bind="foreach: oldTags, css: { 'is-disable' : idField() }">
                                            <div class="btn-selection">
                                                <span data-bind="text: name + ' ' + formattedDataset"></span>
                                            </div>
                                        </div>
                                        <div data-bind="foreach: tags">
                                            <div class="btn-selection">
                                                <span data-bind="text: name"></span>
                                                <button class="icon i-x-after" type="button" data-bind="click: onClickRemoveTag "></button>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko if: $root.headerSubMenu.isMltBrand() -->
                                        <strong class="form-sub-title">Categories</strong>
                                        <div class="form-group relative-current-selection">
                                            ${ this.categoryFilter.getHtmlBuild() }
                                        </div>
                                        <div data-bind="foreach: categories">
                                            <div class="btn-selection">
                                                <span data-bind="text: name"></span>
                                                <button class="icon i-x-after" type="button" data-bind="click: onClickRemoveCategory "></button>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                <!-- /ko -->

                                <!-- ko ifnot: $root.headerSubMenu.isDefaultMenu() -->
                                    <strong class="form-sub-title">Image</strong>
                                    <div class="form-group img">
                                        <div style="border-top: 1px dashed #d3d3d3; margin-top: 3rem; padding-top: 2rem;">
                                            <label for="" class="form-label">Image</label>
                                            ${ this.imageWidgetForBrandTagImage.getHtmlBuild() }
                                        </div>
                                    </div>
                                <!-- /ko -->
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickAddItem}" class="btn highlight">Apply</button>
                            <button type="button" data-bind="event: { click: onClickHideAddItem.bind($data, false)}" class="btn ">Cancel</button>
                        </div>
                    </div>
                </div> 
                    ${ this.imagePicker.getHtmlBuild() }
            </div> `

        );
    }
    protected buildViewModel(): any {
        let huit_neuf_this = this;
        return {
            items: ko.observableArray([]),
            itemsToDelete: ko.observableArray([]),
            maxId: ko.observable(0),
            menuName: ko.observable(''),
            showActionId: ko.observable(null),
            deleteConfirmation: ko.observable(null),
            canSetSection: ko.observable(false),
            canSetStyling: ko.observable(false),
            showAddForm: ko.observable(false),
            addPosition: ko.observable(null),
            siblingOrder: ko.observable(null),
            siblingParent: ko.observable(null),
            itemId: ko.observable(null),
            rootItems: ko.observableArray(null),
            menuStyle: ko.observable(null),
            pageId: ko.observable(null),
            temporaryHolder: ko.observable([]),
            oldTags: ko.observableArray([]),
            tags: ko.observableArray([]),
            categories: ko.observableArray([]),
            isMltBrand: ko.observable(false),
            permissions : ko.observableArray(this.initPermissions(['menu_config_site', 'menu_config_footer'])),
            inSubMenu: ko.observable(false),
            clickedItem: ko.observable(null),
            filteredItems: ko.observableArray([]),
            errorMessage: ko.observable(null),
            removedTags: ko.observableArray([]),
            idField: ko.observable(null),
            isDefaultMenu: ko.observable(false),
            showReLock: ko.observable(false),
            subItemsOf: function (value, data, event) {
                return huit_neuf_this.subItemsOf(value);
            },
            hasSubItems: function (value, data, event) {
                return huit_neuf_this.hasSubItems(value);
            },
            onClickAddRootChild: function () {
                return huit_neuf_this.onClickAddRootChild();
            },
            onClickAddChild: function (data, event) {
                return huit_neuf_this.onClickAddChild(data);
            },
            onClickShowAddBefore: function (data, event) {
                return huit_neuf_this.onClickShowAddBefore(data);
            },
            onClickShowAddAfter: function (data, event) {
                return huit_neuf_this.onClickShowAddAfter(data);
            },
            onClickShowAddSubItem: function (data, event) {
                return huit_neuf_this.onClickShowAddSubItem(data, event);
            },
            onClickHideAddBefore: function (data, event) {
                return huit_neuf_this.onClickHideAddBefore(data);
            },
            onClickHideAddItem: function (data, event) {
                return huit_neuf_this.onClickHideAddItem(data);
            },
            onClickHideAddAfter: function (data, event) {
                return huit_neuf_this.onClickHideAddAfter(data);
            },
            onClickHideAddChild: function (data, event) {
                return huit_neuf_this.onClickHideAddChild(data);
            },
            onClickAddBefore: function (data, event) {
                return huit_neuf_this.onClickAddBefore(data);
            },
            onClickAddItem: function (data, event) {
                return huit_neuf_this.onClickAddItem(data);
            },
            onClickShowAddItem: function (data, event) {
                return huit_neuf_this.onClickShowAddItem(data);
            },
            onClickAddAfter: function (data, event) {
                return huit_neuf_this.onClickAddAfter(data);
            },
            onClickHideEdit: function (data, event) {
                return huit_neuf_this.onClickHideEdit(data);
            },
            onClickShowEdit: function (data, event) {
                return huit_neuf_this.onClickShowEdit(data);
            },
            onClickEdit: function (data, event) {
                return huit_neuf_this.onClickEdit(data);
            },
            onClickSoftDelete: function (data, event) {
                return huit_neuf_this.onClickSoftDelete(data);
            },
            onClickCancelSoftDelete: function () {
                return huit_neuf_this.onClickCancelSoftDelete();
            },
            onClickHardDelete: function (data, event) {
                return huit_neuf_this.onClickHardDelete(data);
            },
            onClickSave: function (data, event) {
                huit_neuf_this.onClickSave();
            },
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            showActions: function (data, event) {
                huit_neuf_this.showActions(data);
            },
            hideActions: function (data, event) {
                huit_neuf_this.hideActions(data);
            },
            onBackAction: function (data, event) {
                huit_neuf_this.onBackAction();
            },
            onClickTrendingStyle: function (data, event) {
                huit_neuf_this.onClickTrendingStyle(data,event);
            },
            onClickShowAddChild: function (data, event) {
                return huit_neuf_this.onClickShowAddChild(data);
            },
            onBackActionToSubMenu: function (data, event) {
                return huit_neuf_this.onBackActionToSubMenu();
            },
            onKeyUpFilterAction: function (data, event) {
              return huit_neuf_this.onKeyUpFilterAction();  
            },
            canAddChild: function (item) {
                const depth = huit_neuf_this.calculateDepth(item, huit_neuf_this.getTemplateViewModel().items());
                return depth < 300; 
            },
            onClickSaveAndStay:function(data,event){
                huit_neuf_this.onClickSaveAndStay(data);
            },
            onClickRemoveTag: function (data, event) {
                huit_neuf_this.onClickRemoveTag(data);
            },
            onClickRemoveCategory: function (data, event) {
                huit_neuf_this.onClickRemoveCategory(data);
            },
            onClickMoveToTop: function (data, event) {
                huit_neuf_this.onClickMoveToTop(data);
            },
            onClickMinimizeExpandChildren: function (data, event) {
                huit_neuf_this.onClickMinimizeExpandChildren(data,event);
            },
            onClickExpandAll: function (data, event) {
                huit_neuf_this.onClickExpandAll(data);
            },
            onClickCloseAll: function (data, event) {
                huit_neuf_this.onClickCloseAll(data);
            },
            onClickRelock: function (data, event){
                huit_neuf_this.onClickRelock(data);
            },
            onClickCancelRelock: function (data, event){
                huit_neuf_this.onClickCancelRelock(data);
            }
        }
    }
    protected getTemplateName(): string {
        return "header_sub_menu_edit_template";
    }


    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "view-tag", "images-align-top-template"];
    }

    public onClickView(id: number) {
    }

    public subItemsOf(item) {
        let items = null;
        
        if(this.getTemplateViewModel().filteredItems().length > 0){
            items = this.getTemplateViewModel().filteredItems();
        }else{
            items = this.getTemplateViewModel().items();
        }
        
        return ko.utils.arrayFilter(items, function (arrayItem) {
            const parentItemId = (null === item) ? null : item.id;
            return arrayItem.idParent == parentItemId;
        });
    }

    public onClickShowAddBefore(data) {

        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.idParent);
        this.getTemplateViewModel().addPosition('before');
        this.getTemplateViewModel().showAddForm(true);
    }

    public onClickShowAddItem(data) {

        let addPosition = 'before';
        if(data.addPosition){
            addPosition =  data.addPosition;
        }
        this.getTemplateViewModel().addPosition(addPosition);
        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.idParent);
        this.getTemplateViewModel().showAddForm(true);
    }

    public onClickShowAddAfter(data) {

        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.idParent);
        this.getTemplateViewModel().addPosition('after');
        this.getTemplateViewModel().showAddForm(true);
    }


    public onClickHideAddItem(data?) {

        this.getTemplateViewModel().showAddForm(false);
        this.tagFilter.setOption(null);
        this.getTemplateViewModel().tags([]);
        this.getTemplateViewModel().categories([]);
        (<HTMLInputElement>document.getElementById("addRootUrl")).value = '';
        (<HTMLInputElement>document.getElementById("addRootLabel")).value = '';
        
        //(<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked = false;
        this.imageWidgetForBrandTagImage.clearImage();
        this.onLoadTemplate('.draggable', this);
    }

    public onClickHideAddAfter(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showAddAfter = false;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickHideAddBefore(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showAddBefore = false;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickHideAddChild(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showAddChild = false;
            }
        }

        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickTrendingStyle(data,event) {
        //we are going to remove all the child items
        let items = this.getTemplateViewModel().items();
        
        // Filter out items with idParent
        let filteredItems = items.filter(item => !item.idParent);
        let deletedItems = items.filter(item => item.idParent && item.id !== null);
        filteredItems.forEach(item => {
            
            if(item.image){
                item.image = null;
            }
        });
        this.getTemplateViewModel().itemsToDelete(deletedItems);
        // Update the items array
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(filteredItems);
        this.getTemplateViewModel().menuStyle(null);
        this.getTemplateViewModel().menuStyle('trending');
    }

    public onClickAddRootChild() {
        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();
        
        let idParent = this.getTemplateViewModel().itemLocationParent()

        let label = (<HTMLInputElement>document.getElementById("addRootLabel")).value;
        let url = (<HTMLInputElement>document.getElementById("addRootUrl")).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addRootStylingStandard_new]:checked`)).value;
        let isSection = (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked;

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            isSection: isSection,
            tmplabel: label,
            tmpurl: url,
            idParent: idParent,
            order: 1,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType
        });
        items.sort(this.sortMenu);

        this.getTemplateViewModel().itemLocationId(null)
        this.getTemplateViewModel().itemLocationParent(null)
        this.getTemplateViewModel().insertPosition(null)

        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickAddItem(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();
        let tags = this.getTemplateViewModel().tags();
        let categories = this.getTemplateViewModel().categories();
        let url = (<HTMLInputElement>document.getElementById("addRootUrl")).value;
        let label = (<HTMLInputElement>document.getElementById("addRootLabel")).value;
        let image = this.imageWidgetForBrandTagImage.getImage();

        this.validateUrl(url)


        let newOrder = 0;
        if(this.getTemplateViewModel().addPosition()) {

            if (this.getTemplateViewModel().addPosition() == "before") {
                newOrder = this.getTemplateViewModel().siblingOrder();

            } else {
                newOrder = this.getTemplateViewModel().siblingOrder() + 1;
            }
            let itemParent = this.getTemplateViewModel().siblingParent();
            for (let item of items) {
                if (item.idParent == itemParent && item.order >= newOrder) {
                    item.order = item.order + 1;
                }

                if(item.id == data.id){
                    item.showAddBefore = false;
                }
                
            }
            maxId = maxId + 1;
            let obj = {
                id: maxId,
                label: label,
                url: url,
                tmplabel: label,
                tmpurl: url,
                image: image,
                idParent: itemParent,
                order: newOrder,
                showAddBefore: false,
                showAddAfter: false,
                showAddChild: false,
                showEdit: false,
                tags: tags,
                categories: categories,
                isLocked: false,
                lockedBy: null
            };
            items.push(obj);
            for(let item of items){
                if (item.id == obj.id) {
                    item.containsChild = ko.observable(false);
                }
                if(item.idParent == itemParent){
                    item.hidemyself = ko.observable(false);                    
                }
            }
            let sameParent = items.filter(e => e.idParent == itemParent);
            sameParent.sort(this.sortMenu);

            let diffParent = items.filter(e => e.idParent != itemParent);

            items = sameParent.concat(diffParent)

            let filteredItems = this.getTemplateViewModel().filteredItems();
            if(filteredItems && filteredItems.length > 0){
                filteredItems.push(obj);
                this.getTemplateViewModel().filteredItems([]);
                this.getTemplateViewModel().filteredItems(filteredItems);
            }
        } else {
            let itemId = this.getTemplateViewModel().itemId();
            for (let item of items) {
                if(item.id == itemId) {
                    item.label = label;
                    item.url = url;
                    item.image = image;
                    item.tags = tags;
                    item.categories = categories;
                    break;
                }
            }
        }
        
        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().addPosition(null);
        this.getTemplateViewModel().siblingOrder(null);
        this.getTemplateViewModel().siblingParent(null);
        (<HTMLInputElement>document.getElementById("addRootUrl")).value = '';
        (<HTMLInputElement>document.getElementById("addRootLabel")).value = '';
        this.getTemplateViewModel().showAddForm(false);
        this.tagFilter.setOption(null);
        this.getTemplateViewModel().tags([]);
        this.getTemplateViewModel().categories([]);
        this.onLoadTemplate('.draggable', this);
        this.imageWidgetForBrandTagImage.clearImage();

    }

    public onClickAddBefore(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let newOrder = data.order;
        for (let item of items) {
            if (item.idParent == data.idParent && item.order >= newOrder) {
                item.order = item.order + 1;
            }

            if (item.id == data.id) {
                item.showAddBefore = false;
            }
        }

        let label = (<HTMLInputElement>document.getElementById("addBeforeLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addBeforeUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addBeforestyleType_${data.id}]:checked`)).value;

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            isSection: false,
            tmplabel: label,
            tmpurl: url,
            idParent: data.idParent,
            order: newOrder,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType
        });

        items.sort(this.sortMenu)
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().addPosition(null);
        this.getTemplateViewModel().siblingOrder(null);
        this.getTemplateViewModel().siblingParent(null);
        this.getTemplateViewModel().showAddForm(false);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickAddAfter(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let newOrder = data.order + 1;
        for (let item of items) {
            if (item.idParent == data.idParent && item.order >= newOrder) {
                item.order = item.order + 1;
            }

            if (item.id == data.id) {
                item.showAddAfter = false;
            }
        }

        let label = (<HTMLInputElement>document.getElementById("addAfterLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addAfterUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addAfterstyleType_${data.id}]:checked`)).value;

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            isSection: false,
            tmplabel: label,
            tmpurl: url,
            idParent: data.idParent,
            order: newOrder,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType
        });
        items.sort(this.sortMenu);

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().addPosition(null);
        this.getTemplateViewModel().siblingOrder(null);
        this.getTemplateViewModel().siblingParent(null);
        this.getTemplateViewModel().showAddForm(false);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickAddChild(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let label = (<HTMLInputElement>document.getElementById("addChildLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addChildUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=childstyleType_${data.id}]:checked`)).value;

        for (let item of items) {

            if (item.id == data.id) {

                item.showAddChild = false;
            }
        }

        maxId = maxId + 1;
        let obj = {
            id: maxId,
            label: label,
            url: url,
            tmplabel: label,
            tmpurl: url,
            idParent: data.id,
            order: 1,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType,
            isSection: false,
        }
        items.push(obj);

        items.sort(this.sortMenu);
        for(let item of items){
            if(item.id == data.idParent){
                item.hidemyself = ko.observable(false);
                
            }
            if(item.id == data.id){
                item.containsChild = ko.observable(false);
            }
        }
        
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickShowEdit(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {

                (<HTMLInputElement>document.getElementById("addRootLabel")).value = item.label;
                if(item.tags){
                    this.setTags(item.tags);
                }
                if(item.categories){
                    this.setCategories(item.categories);
                }
                (<HTMLInputElement>document.getElementById("addRootUrl")).value = item.url;
                
                if(item.image){
                    this.imageWidgetForBrandTagImage.setImage(item.image);
                }
                // //let style = ;
                // (<HTMLInputElement>document.getElementById("addRootStylingStandard_new")).checked = true;
                // (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked = item.isSection;

                this.getTemplateViewModel().itemId(data.id);
                this.getTemplateViewModel().siblingOrder(data.order);
                this.getTemplateViewModel().siblingParent(data.idParent);
                this.getTemplateViewModel().showAddForm(true);
                break;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
    }

    public onClickHideEdit(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showEdit = false;
                item.tmplabel = item.label;
                item.tmpurl = item.url;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickEdit(data) {

        let itemId = this.getTemplateViewModel().itemId();
        let items = this.getTemplateViewModel().items();

        let label = (<HTMLInputElement>document.getElementById("addChildLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addChildUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=childstyleType_${data.id}]:checked`)).value;

        for (let item of items) {
            if (item.id == data.id) {
                item.label = item.tmplabel;
                item.url = item.tmpurl;
                item.showEdit = false;

            }
        }

        items.sort(this.sortMenu);

        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickSoftDelete(item) {

        this.getTemplateViewModel().deleteConfirmation(item)
    }

    public onClickCancelSoftDelete() {

        this.getTemplateViewModel().deleteConfirmation(null)
    }

    public onClickHardDelete(itemToDelete) {
        let items_to_delete = this.getTemplateViewModel().itemsToDelete()
        items_to_delete.push(itemToDelete)

        let children = this.subItemsOf(itemToDelete);
        for (let child of children) {
            this.onClickHardDelete(child);
        }

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == itemToDelete.id) {
                let index = items.findIndex(items => items.id == item.id);
                if (index != -1) {
                    items.splice(index, 1);
                }
            }

        }
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().itemsToDelete(items_to_delete)
        this.getTemplateViewModel().deleteConfirmation(null);
        this.onLoadTemplate('.draggable', this);
    }

    public showActions(data) {

        this.getTemplateViewModel().showActionId(data.id);
    }

    public hideActions(data) {

        this.getTemplateViewModel().showActionId(null);
    }

    public hasSubItems(item) {
        var firstMatch = ko.utils.arrayFirst(this.getTemplateViewModel().items(), function (arrayItem) {
            return (arrayItem.idParent == item.id);
        });
        return (null !== firstMatch && typeof firstMatch !== "undefined"); // At least one item found in array
    }

    public setMenuItems(menuItems,maxId,menuStyle) {

        let items = [];
        let rootItems = [];
        let uniqueId = 0;
        let menuName = '';
        let parentIds = [];
        let childParentMap = {};

        
        for (let [index, item] of menuItems.entries()) {
            if ((typeof item.menu !== 'undefined') && (typeof item.menu.name !== 'undefined')) {
                menuName = item.menu.name;
            }

            if(item.idParent == null ){
                rootItems.push(item.id);
                childParentMap[item.idParent] = true;
            }

            if (item.idParent) {
                if (!childParentMap[item.idParent]) {
                    childParentMap[item.idParent] = true; 
                }
            }
            
            items.push({
                id: item.id,
                label: item.label,
                url: item.url,            
                tmplabel: item.label,
                tmpurl: item.url,
                idParent: item.idParent,
                order: item.order,
                image: item.image,
                showAddBefore: false,
                showAddAfter: false,
                showAddChild: false,
                showEdit: false,
                showActionas: false,
                uniqueId: index,
                tmpStyle: item.styleType,
                isSection: false,
                tags: item.idTags ? item.idTags : item.tags,
                categories: item.idCategories ? item.idCategories : (item.categories || []),
                isLocked: item.isLocked,
                lockedBy: item.lockedBy
            });
        }
        parentIds = Object.keys(childParentMap);
        
        for (let item of items) {
            // Determine if the item has children
            const hasChildren = items.some(child => child.idParent === item.id);
            
            // True if the item has children
            item.containsChild = hasChildren;

            // Hide non-root items by default
            item.hidemyself = ko.observable(item.idParent !== null); 
        }

        items.sort(this.sortMenu);

        this.getTemplateViewModel().rootItems([])
        this.getTemplateViewModel().rootItems(rootItems)
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().menuName(menuName);
        let canSetSection = (menuName == 'site' ? true : false)
        let canSetStyling = (menuName == 'site' ? true : false)
        this.getTemplateViewModel().canSetSection(canSetSection);
        this.getTemplateViewModel().canSetStyling(canSetStyling);
        if(menuItems[0]){
            this.getTemplateViewModel().pageId(menuItems[0].idMenu);
        }else{
            this.getTemplateViewModel().pageId(0);
        }

        this.getTemplateViewModel().menuStyle(menuStyle);

        this.onLoadTemplate('.draggable', this);

    }

    public sortMenu(a, b) {

        var o1 = a['idParent'];
        var o2 = b['idParent'];

        var p1 = a['order'];
        var p2 = b['order'];

        if (o1 < o2) return -1;
        if (o1 > o2) return 1;
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
    }

    protected onClickSave() {

        this.caller.save();
    }

    protected onClickCancel() {

        this.caller.cancel();
    }


    public onBackAction() {
        if(this.getTemplateViewModel().inSubMenu()){
            this.getTemplateViewModel().items(this.getTemplateViewModel().temporaryHolder());
            this.getTemplateViewModel().temporaryHolder([]);
            this.getTemplateViewModel().inSubMenu(false);
        }else{

            this.caller.backAction();
        }
    }

    public getAncestors(id){
        let huit_neuf_this = this;

        let ancestors = [];
        let items = huit_neuf_this.getTemplateViewModel().items();

        let parent = items.find(e => e.id == id);
        if(parent && parent.idParent != null){

            let ances = this.getAncestors(parent.idParent);
            ancestors = ancestors.concat(ances)
            ancestors.push(parent.id)

        } else {
            ancestors.push(id)
        }
        return ancestors;
    }

    private onLoadTemplate(dragItemSelector, huit_neuf) {

        var dragSrcEl = null;
        var dragSrcId = null;
        var dragItemIdPrefix = "draggableMenuItem_";

        function handleDragStart(e) {

            // @TODO: remove any elements visible because the dragged element was hovered

            if (e.stopPropagation) {
                e.stopPropagation(); // Prevent the parent item from being considered the dragged item
            }

            // Target (this) element is the source node.
            dragSrcEl = this;
            dragSrcId = e.srcElement.id;

            // hide actions
            huit_neuf.hideActions(null);

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }

        function handleDragOver(e) {

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            if (e.stopPropagation) {
                e.stopPropagation(); // Prevent the parent/child element from both being 'dragged over' simultaneously
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {

                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {

            // this / e.target is the current hover target.
            this.classList.add('over');
            this.classList.add('before');
        }

        function handleDragLeave(e) {

            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {

            // @TODO not type safe in here..

            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {

                //let success = true;
                let items = huit_neuf.getTemplateViewModel().items();
                let destinationID = this.id;
                let dragSrcIdInt = parseInt(dragSrcId.substring(dragItemIdPrefix.length)); // integer id of the element that was dragged..
                destinationID = (destinationID.indexOf(dragItemIdPrefix) >= 0) ? parseInt(destinationID.substring(dragItemIdPrefix.length)) : null; // the destination element ID is the number after "draggableMenuItem_" in the ID or null if the prefix is missing
                let oldElement = document.querySelector('.nav-builder-entry[id=\'' + dragSrcId + '\']');
                //var dropHTML = e.dataTransfer.getData('text/html'); // @TODO remove dataTransfer?
                let dropHTML = oldElement.outerHTML;
                let disallowDrop = false;

                let ancestors = huit_neuf.getAncestors(destinationID,);

                if(ancestors.indexOf(dragSrcIdInt) != -1){
                    disallowDrop = true;
                }

                if(disallowDrop){
                    return;
                }
                //remove the element that was dragged
                oldElement.remove();

                if (this.classList.contains("before")) {

                    this.insertAdjacentHTML('beforebegin', dropHTML);
                    var relativePosition = 'before';
                } else {

                    this.insertAdjacentHTML('afterend', dropHTML);
                    var relativePosition = 'after';
                }

                // re-arrange the items in the model based on the new order.
                // loop through to get the necessary data..
                for (let item of items) {

                    if (item.id == dragSrcIdInt) {

                        var popItem = item;
                    }
                    if (item.id == destinationID) {

                        var destItem = item;
                        var parentID = destItem.idParent;
                        var popItemPos = (relativePosition == 'before') ? destItem.order : destItem.order + 1; // if placed before, the moved item will take the destination items position, if moved after it will move to the destination item position plus 1
                    }
                } // end for

                // loop through again to change all the affected entries
                for (let key in items) {

                    if (items[key].id == dragSrcIdInt) {

                        items[key].order = popItemPos;
                        items[key].idParent = parentID;
                    } else if ((items[key].order >= popItemPos) && (items[key].idParent == parentID)) {

                        items[key].order = items[key].order + 1;
                    }
                } // end for

                items.sort(huit_neuf.sortMenu);
                huit_neuf.getTemplateViewModel().items([]);
                huit_neuf.getTemplateViewModel().items(items);
                huit_neuf.onLoadTemplate('.draggable', huit_neuf);

                //} // end if (success == true)

            }

            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {

            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {

                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {

            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);
        }

        var cols = document.querySelectorAll('[draggable=true]');
        //var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    public setPermissions(permissions){
        //this.getTemplateViewModel().permissions([]);
        this.getTemplateViewModel().permissions(permissions);
    }

    private onClickShowAddSubItem(data, event) {
        
        this.caller.valnetLocker(data.id, 'lock');
        let allItems = this.getTemplateViewModel().items(); 
        
        let clickedItemId = data.id; 
    
    
        const getAllChildItems = (parentId) => {
            return allItems.filter(item => item.idParent === parentId).reduce((acc, child) => {
                return acc.concat(child, getAllChildItems(child.id)); 
            }, []);
        };
    
        let childItems = getAllChildItems(clickedItemId);
        let maxId = Math.max(
            ...allItems.map(item => item.id),
            ...childItems.map(item => item.id),
            0
        );
    
        childItems.forEach(item => {
            if (item.idParent === clickedItemId) {
                item.idParent = null; 
            }
        });
        // Remove child items from allItems and place them in temporaryHolder
        let remainingItems = allItems.filter(item => !childItems.some(child => child.id === item.id));
        this.getTemplateViewModel().temporaryHolder(remainingItems);
        this.searchFilter.getTemplateViewModel().filterKeyword("");
        this.searchFilter.getTemplateViewModel().filterInputClearButton(0)
        this.getTemplateViewModel().filteredItems([]);
        this.setMenuItems(childItems,maxId, "Trending");
        // Update state for clicked item and UI changes
        this.getTemplateViewModel().clickedItem(clickedItemId);
        this.getTemplateViewModel().inSubMenu(true);
    }
    
    

    public onClickShowAddChild(data) {

        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.id);
        this.getTemplateViewModel().addPosition('after');
        this.getTemplateViewModel().showAddForm(true);
    }

    public onBackActionToSubMenu(isOnSaveAction = false) {
        
        let tempItems = this.getTemplateViewModel().temporaryHolder(); 
        let clickedItemId = this.getTemplateViewModel().clickedItem(); 
        let childItems = this.getTemplateViewModel().items(); 
        let maxId = Math.max(
            ...tempItems.map(item => item.id),
            ...childItems.map(item => item.id),
            0 // Default value if both arrays are empty
        );
        for(let i = 0; i < childItems.length; i++){
            if(childItems[i].idParent == null){
                childItems[i].idParent = clickedItemId;
            }
        }
        
        for (let item of tempItems) {
            if (item.id === clickedItemId) {
        
                childItems.forEach((child, index) => {
                    
                    if (!tempItems.some(tempItem => tempItem.id === child.id)) {
                        tempItems.push({
                            ...child,                            
                            order: index + 1 
                        });
                    }
                });
                break;
            }
        }
    
        // Restore the original state
        if(!isOnSaveAction){
            this.caller.valnetLocker(this.getTemplateViewModel().clickedItem(), 'unlock');
            this.restoreOriginalState(tempItems,maxId);
            this.caller.stopEditingTimer();
        }
    }

    private restoreOriginalState(tempItems,maxId){
        this.setMenuItems(tempItems,maxId, "Trending");
        this.getTemplateViewModel().temporaryHolder([]); 
        this.getTemplateViewModel().clickedItem(null); 
        this.getTemplateViewModel().inSubMenu(false); 
    }
    
    
    public onKeyUpFilterAction() {
        let items = this.getTemplateViewModel().items();
        let filterItem = this.searchFilter.getTemplateViewModel().filterKeyword()
        
        //make an autocomplete list filterItem is the searched word on items
        if(filterItem){

            let filteredItems = items.filter(item => item.label.toLowerCase().includes(filterItem.toLowerCase()));
            let tempChildItems = [];
            //need to also find the child items of all filtered items
            for(let i = 0; i < filteredItems.length; i++){
                let childItems = items.filter(item => item.idParent == filteredItems[i].id);
                tempChildItems.push(...childItems);
                //filteredItems[i].childItems = childItems;
            }
            filteredItems.push(...tempChildItems);
            this.getTemplateViewModel().filteredItems(filteredItems);
        }else{
            this.getTemplateViewModel().filteredItems([]);
            this.setMenuItems(items, this.getTemplateViewModel().maxId(), "Trending");
        }
        
        
    }

    public onClickCancelSearch(){
        this.setMenuItems(this.getTemplateViewModel().items(), this.getTemplateViewModel().maxId(), "Trending");
    }

    public calculateDepth(item, allItems, currentDepth = 1): number {
        if (!item || !item.idParent) {
            return currentDepth;
        }
    
        const parentItem = allItems.find(i => i.id === item.idParent);
        if (parentItem) {
            return this.calculateDepth(parentItem, allItems, currentDepth + 1);
        }
    
        return currentDepth;
    }
    public onClickSaveAndStay(data){
        this.caller.save('stay');
    }

    private onClickRemoveTag(data){
        const tags = this.getTemplateViewModel().tags();
        const filteredTags = tags.filter((tt) => tt.id !== data.id);
        
        let removedTags = this.getTemplateViewModel().removedTags()
        removedTags.push(data.id());
        this.getTemplateViewModel().removedTags([]);
        this.getTemplateViewModel().removedTags(removedTags);
        // Update the observable array
        this.getTemplateViewModel().tags(filteredTags); 
    }

    public setTags(tags): void {

        let self = this; 

        tags.forEach((tag) => {
            // Convert properties into observables
            if(!(ko.isObservable(tag.name) && ko.isObservable(tag.id))){

                tag.name = ko.observable(tag.name);   
                tag.id = ko.observable(tag.id);
        
                // Add an event function for removing this specific tag
                tag.onClickRemoveTag = function () {
                    self.onClickRemoveTag(tag); 
                };
            }
        });
    
        
        this.getTemplateViewModel().tags([]);
        this.getTemplateViewModel().tags(tags);
    }

    public onClickRemoveCategory(data){
        const categories = this.getTemplateViewModel().categories();
        const filteredCategories = categories.filter((cat) => cat.id !== data.id);
        this.getTemplateViewModel().categories(filteredCategories);
    }

    public setCategories(categories): void {
        let self = this;

        categories.forEach((cat) => {
            if(!(ko.isObservable(cat.name) && ko.isObservable(cat.id))){
                cat.name = ko.observable(cat.name);
                cat.id = ko.observable(cat.id);
                cat.onClickRemoveCategory = function () {
                    self.onClickRemoveCategory(cat);
                };
            }
        });

        this.getTemplateViewModel().categories([]);
        this.getTemplateViewModel().categories(categories);
    }

    public setIsMltBrand(isMlt) {
        this.getTemplateViewModel().isMltBrand(isMlt);
    }

    public setIsDefaultMenu(isDefaultMenu) {
        this.getTemplateViewModel().isDefaultMenu(isDefaultMenu);
    }

    public onClickMoveToTop(data) {
        
        let items = this.getTemplateViewModel().items();
        let minOrder = Math.min(...items.map(item => item.order));
        //set clicked item to minOrder and shift all other items down
        let updatedItems = items.map(item => {
            if (item.id === data.id) {
                return { ...item, order: minOrder }; 
            } else {
                return { ...item, order: item.order + 1 };
            }
        });
        this.getTemplateViewModel().items([]);
        this.setMenuItems(updatedItems, this.getTemplateViewModel().maxId(), "Trending");
        
    }

    public onClickMinimizeExpandChildren(data, event) {
        let items = this.getTemplateViewModel().items();
        let parentIdOfClickedItem = data.id;

        for (let item of items) {
            if (item.idParent === parentIdOfClickedItem) {
                let flip = item.hidemyself();
                item.hidemyself(!flip);
            }
        }

        // Toggle the arrow direction
        const isMinimized = event.currentTarget.style.transform === "rotate(180deg)";
        event.currentTarget.style.transform = isMinimized ? "rotate(0deg)" : "rotate(180deg)";
    }

    public onClickExpandAll(data) {
        let items = this.getTemplateViewModel().items();
        //set all items to visible
        for (let item of items) {
            if(item.idParent == this.getTemplateViewModel().clickedItem()){
                item.idParent = null;
            }
            item.hidemyself(false);
        }
        let allSpanItems = document.querySelectorAll('.btn.no-bg.child.icon.i-dropdown-simple-b:not([style*="display: none"])');
        for (let spanItem of allSpanItems) {
            const element = spanItem as HTMLElement;
            const isMinimized = element.style.transform === "rotate(180deg)";
            if (isMinimized) {
                element.style.transform = "rotate(0deg)"; 
            }
        }
        this.getTemplateViewModel().items(items);
    }

    public onClickCloseAll(data) {

        let items = this.getTemplateViewModel().items();
        //set all items to hidden
        for (let item of items) {
            if(item.idParent == this.getTemplateViewModel().clickedItem()){
                item.idParent = null;
            }
            if(item.idParent !=null){
                
                item.hidemyself(true);
            }
        }
        let allSpanItems = document.querySelectorAll('.btn.no-bg.child.icon.i-dropdown-simple-b');
        for (let spanItem of allSpanItems) {
            const element = spanItem as HTMLElement;
            const isMaximized = element.style.transform === "rotate(0deg)";
            if (isMaximized) {
                element.style.transform = "rotate(180deg)";
            }
        }
        this.getTemplateViewModel().items(items);
    }

    public stillEditing(){
        this.getTemplateViewModel().showReLock(true);
    }
    public onClickRelock(data){
        this.caller.valnetLocker(this.getTemplateViewModel().clickedItem(), 'refresh');
        this.getTemplateViewModel().showReLock(false);
    }
    public onClickCancelRelock (data){
        this.getTemplateViewModel().showReLock(false);
        this.onBackActionToSubMenu();
    }

    private validateUrl(url: string, isSection = false): void {

        const isEmptyUrl = url.trim().length === 0;
        if (isEmptyUrl) {
            return;
        }

        if (isSection && isEmptyUrl) {
            return;
        }

        const isValidUrl = /^(\/(?!\/)(?!http|https)|https?:\/\/)/.test(url);

        if (!isValidUrl) {
            this.onClickHideAddItem();
            const validation_template = this.caller.validationTemplate;
            const messageString = "URL needs to start with '/', 'http://', or 'https://'.";

            if (validation_template) {
                const message = [
                    {
                        field: "url",
                        label: "URL",
                        messages: [messageString]
                    }
                ];
                validation_template.setMessages(message);
                setTimeout(() => validation_template.clearMessages(), 4000);
            } else {
                console.error(messageString);
            }

            throw new Error(messageString);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/header_sub_menu_edit_template.ts